module.exports = __webpack_public_path__ + "static/logos/logo-skiset--color-c9c2e3896b16b717d9e1a7c5ed218697.svg";